// CANONICAL COPY: installations\smart-td\content\arbitrationDocket.js (ruling 321 slice 3c, task list section 737). src\data\arbitrationDocket.js is its
// projection, written by scripts\sync-installation.js. GENERATED - edit the CSV named below and regenerate; an edit made only to the projection is refused.
// GENERATED FILE - DO NOT EDIT BY HAND.
// Source: data/YCP_ARBITRATION_DOCKET.csv (the arbitration docket of record).
// Regenerate: node scripts/gen-arbitration-docket.js
// Generated: 2026-10-21
//
// WHAT IS AND IS NOT HERE. Every column of the CSV except `claimant` and `carrier_claim_number`.
// Those two are withheld from the browser bundle on purpose - this module is a clock and a pointer
// to the document on disk, not a case file, and the bundle is a public static asset. The CSV in
// data\ carries every column and remains the complete record (PD-1).
//
// The generator REFUSES to emit a row whose record_class is LIVE. A live arbitration case names a
// member, and a member's name does not go into a public asset. When the first live case exists the
// docket moves to Firestore behind committee scoping; this file keeps the closed history.
//
// 4 row(s), all DEAD_FILE.
export const ARBITRATION_DOCKET = [
  {
    "case_id": "ARB-0001",
    "board": "NRAB",
    "division": "Fourth",
    "docket_number": "NRAB-00004-260004",
    "case_type": "claim",
    "subject_code": "312",
    "subject": "Scope",
    "notice_of_intent_date": "2026-06-13",
    "acknowledged_date": "2026-06-15",
    "submission_due": "2026-08-29",
    "submission_filed_date": "",
    "status": "notice_acknowledged",
    "source_document": "data/cases/NRAB_4TH_DIV_NOTICES_CSX-SMART_2026-06-15.pdf",
    "record_class": "DEAD_FILE",
    "record_class_note": "OUT OF SCOPE - NOT invented data, and NOT to be purged. Bob 2026-08-28: these are REAL cases that GC Christian Eckert is handling OUTSIDE this platform; for platform purposes they are dead and not viable. The four NRAB acknowledgement letters are genuine documents on disk at data/cases/NRAB_4TH_DIV_NOTICES_CSX-SMART_2026-06-15.pdf, and he filed the submissions - but the PLATFORM DOES NOT HOLD THE FILING DATES. submission_filed_date is DELIBERATELY BLANK on these four rows and is not missing data: amended 2026-08-31 on Bob's instruction rather than backfilling four dates from a GC on cases he handles elsewhere. A blank here must never be read as 'not filed'. RULING 52's L-0 purge must NOT take these: ruling 30 governs - segregate, do not destroy. Retained as the worked example the arbitration layer was designed against. Watched by nothing."
  },
  {
    "case_id": "ARB-0002",
    "board": "NRAB",
    "division": "Fourth",
    "docket_number": "NRAB-00004-260005",
    "case_type": "claim",
    "subject_code": "312",
    "subject": "Scope",
    "notice_of_intent_date": "2026-06-13",
    "acknowledged_date": "2026-06-15",
    "submission_due": "2026-08-29",
    "submission_filed_date": "",
    "status": "notice_acknowledged",
    "source_document": "data/cases/NRAB_4TH_DIV_NOTICES_CSX-SMART_2026-06-15.pdf",
    "record_class": "DEAD_FILE",
    "record_class_note": "OUT OF SCOPE - NOT invented data, and NOT to be purged. Bob 2026-08-28: these are REAL cases that GC Christian Eckert is handling OUTSIDE this platform; for platform purposes they are dead and not viable. The four NRAB acknowledgement letters are genuine documents on disk at data/cases/NRAB_4TH_DIV_NOTICES_CSX-SMART_2026-06-15.pdf, and he filed the submissions - but the PLATFORM DOES NOT HOLD THE FILING DATES. submission_filed_date is DELIBERATELY BLANK on these four rows and is not missing data: amended 2026-08-31 on Bob's instruction rather than backfilling four dates from a GC on cases he handles elsewhere. A blank here must never be read as 'not filed'. RULING 52's L-0 purge must NOT take these: ruling 30 governs - segregate, do not destroy. Retained as the worked example the arbitration layer was designed against. Watched by nothing."
  },
  {
    "case_id": "ARB-0003",
    "board": "NRAB",
    "division": "Fourth",
    "docket_number": "NRAB-00004-260006",
    "case_type": "claim",
    "subject_code": "312",
    "subject": "Scope",
    "notice_of_intent_date": "2026-06-13",
    "acknowledged_date": "2026-06-15",
    "submission_due": "2026-08-29",
    "submission_filed_date": "",
    "status": "notice_acknowledged",
    "source_document": "data/cases/NRAB_4TH_DIV_NOTICES_CSX-SMART_2026-06-15.pdf",
    "record_class": "DEAD_FILE",
    "record_class_note": "OUT OF SCOPE - NOT invented data, and NOT to be purged. Bob 2026-08-28: these are REAL cases that GC Christian Eckert is handling OUTSIDE this platform; for platform purposes they are dead and not viable. The four NRAB acknowledgement letters are genuine documents on disk at data/cases/NRAB_4TH_DIV_NOTICES_CSX-SMART_2026-06-15.pdf, and he filed the submissions - but the PLATFORM DOES NOT HOLD THE FILING DATES. submission_filed_date is DELIBERATELY BLANK on these four rows and is not missing data: amended 2026-08-31 on Bob's instruction rather than backfilling four dates from a GC on cases he handles elsewhere. A blank here must never be read as 'not filed'. RULING 52's L-0 purge must NOT take these: ruling 30 governs - segregate, do not destroy. Retained as the worked example the arbitration layer was designed against. Watched by nothing."
  },
  {
    "case_id": "ARB-0004",
    "board": "NRAB",
    "division": "Fourth",
    "docket_number": "NRAB-00004-260007",
    "case_type": "claim",
    "subject_code": "312",
    "subject": "Scope",
    "notice_of_intent_date": "2026-06-13",
    "acknowledged_date": "2026-06-15",
    "submission_due": "2026-08-29",
    "submission_filed_date": "",
    "status": "notice_acknowledged",
    "source_document": "data/cases/NRAB_4TH_DIV_NOTICES_CSX-SMART_2026-06-15.pdf",
    "record_class": "DEAD_FILE",
    "record_class_note": "OUT OF SCOPE - NOT invented data, and NOT to be purged. Bob 2026-08-28: these are REAL cases that GC Christian Eckert is handling OUTSIDE this platform; for platform purposes they are dead and not viable. The four NRAB acknowledgement letters are genuine documents on disk at data/cases/NRAB_4TH_DIV_NOTICES_CSX-SMART_2026-06-15.pdf, and he filed the submissions - but the PLATFORM DOES NOT HOLD THE FILING DATES. submission_filed_date is DELIBERATELY BLANK on these four rows and is not missing data: amended 2026-08-31 on Bob's instruction rather than backfilling four dates from a GC on cases he handles elsewhere. A blank here must never be read as 'not filed'. RULING 52's L-0 purge must NOT take these: ruling 30 governs - segregate, do not destroy. Retained as the worked example the arbitration layer was designed against. Watched by nothing."
  }
];

// The two values declared at data/YCP_DEAD_FILE_MARKING_2026-08-27.md SS3.1. Not a third
// vocabulary invented in the UI.
export const RECORD_CLASSES = ["LIVE","DEAD_FILE"];
